import React, { Component, Fragment } from 'react';
import Wrapper from './../../../../../common/component/Wrapper';
import {
    getTitleTable, formatMoney, columnsTable,
    getDataSource, genaratePaginateFilterSort,
    getPermissionActions
} from '../../../../../../../helpers/functions';
import { parseListRequestParams, getLocaleFullName } from '../../../../../../../utils/commonUtils';
import * as HMS from "../../../../../common/component/Index";
import * as Func from '../../../../../../../helpers/functions';
import SaleReportByOrder from '../../../../../../../models/SaleReportByOrder';
import DEFINE, { CHANNELS, DATE_TIME_FORMAT, ORDER, SALE_CHANNELS } from '../../../../../../../constants/Define';
import { FormWrapperItem, ListComponent, DatePickerComponent } from '../../../../../common/component/Index';
import Button, { ButtonGroup } from '../../../../../common/component/Button';
import * as ANT from 'antd';
import { omit, find } from 'lodash';
import i18n from "../../../../../../../constants/initLng";
import FontIcon, { SolidIcons } from '../../../../../common/component/FontIcon';
import Span from '../../../../../common/component/Span';
import moment from 'moment';
// import './ReportList.less';

let permisionActions = [];
const defaultState = {
    filterExport: {}
};

const ReportListCols = ['id', 'itemTypes', 'orderCode', 'transactionId', 'paymentType', 'paymentStatus', 'status', 'fullname', 'phoneNumber', 'email', 'emailHistories', 'createdDate', 'saleChannel', 'channel', 'subTotal', 'totalAmount', 'totalSurcharge','totalChangeRateCode', 'couponCode', 'couponValue', 'currencyCode', 'firstname', 'lastname', 'note'];
const removeColumns = ['id', 'saleReportByOrderItems', 'firstname', 'lastname', 'couponCode', 'couponValue', 'currencyCode', 'emailHistories', 'note', 'totalSurcharge', 'subTotal'];

let orderOnline = ['onepay', 'vnpay', 'onepay_installment']

const CURRENT_DATE_RANGE_ENUM = {
    DATE: [moment.utc().startOf('days'), moment.utc().endOf('days')],
    WEEK: [moment.utc().startOf('isoWeeks'), moment.utc().endOf('days')],
    MONTH: [moment.utc().startOf('months'), moment.utc().endOf('days')],
}
export default class ReportList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: getTitleTable(ReportListCols, [], removeColumns),
            modelItem: ReportListCols,
            componentTable: {
                createdDate: {
                    render: (text, record) => record.createdDate && record.createdDate.format(DATE_TIME_FORMAT.SHORT_DATE),
                    // sorter: (i, k) => i.createdDate.length - k.length,
                    key: 'createdDate',
                },
                fullname: {
                    key: 'fullname',
                    render: (text, data) => data.fullname || getLocaleFullName(data.firstname, data.lastname),
                    // filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    //     <HMS.FilterDropdown
                    //         setSelectedKeys={setSelectedKeys}
                    //         selectedKeys={selectedKeys}
                    //         confirm={confirm}
                    //         clearFilters={clearFilters}
                    //     >
                    //     </HMS.FilterDropdown>
                    // ),
                    // filterIcon: filtered => (
                    //     <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    // ),
                },
                transactionId: {
                    render: (transactionId, record) => orderOnline.includes(record.paymentType) ? record.id : transactionId
                }, 
                subTotal: {
                    // sorter: (i, k) => i.subTotal.length - k.length,
                    align: "right",
                    render: (subTotal) => Func.formatMoney(subTotal)
                },
                totalSurcharge: {
                    // sorter: (i, k) => (i.surcharge || '').length - k.length,
                    align: "right",
                    render: (surcharge) => Func.formatMoney(surcharge)
                },
                totalChangeRateCode: {
                    align: 'right',
                    width: 200,
                    render: (surcharge) => Func.formatMoney(surcharge)
                },
                totalAmount: {
                    // sorter: (i, k) => (i.surcharge || '').length - k.length,
                    align: "right",
                    render: (amount) => Func.formatMoney(amount)
                },
                status: {
                    key: 'status',
                    render: (status, data) => <Fragment>
                        <HMS.StatusComponent color={status === 2 ? 'green' : (status === 4 ? 'blue' : 'red')}
                            label={i18n.t(`item.order.orderStatus.${status}`)} />
                        
                    </Fragment>,
                    // filters: [
                    //     { value: 1, text: this.props.t(`item.order.orderStatus.1`) },
                    //     { value: 2, text: this.props.t(`item.order.orderStatus.2`) },
                    //     // { value: 3, text: this.props.t(`item.order.orderStatus.3`) },
                    //     { value: 4, text: this.props.t(`item.order.orderStatus.4`) },
                    //     // { value: 5, text: this.props.t(`item.order.orderStatus.5`) },
                    //     { value: 6, text: this.props.t(`item.order.orderStatus.6`) },
                    //     // { value: 7, text: this.props.t(`item.order.orderStatus.7`) },
                    //     { value: 8, text: this.props.t(`item.order.orderStatus.8`) },
                    //     { value: 9, text: this.props.t(`item.order.orderStatus.9`) },
                    // ],
                    // filterMultiple: false,
                },
                paymentStatus: {
                    key: 'paymentStatus',
                    render: (paymentStatus, data) => <Fragment>
                        <HMS.StatusComponent color={paymentStatus === 2 ? 'green' : (paymentStatus === 4 ? 'blue' : 'red')}
                            label={i18n.t(`item.order.paymentStatusEnum.${paymentStatus}`)} />
                        {/* {(data.paymentStatus === 2 || data.paymentStatus === 4) && data.paymentType && <div className="g-mt-5">
                                <HMS.StatusComponent color={'gray'}
                                    label={i18n.t(`item.order.paymentTypes.${data.paymentType}`)} />
                        </div>
                        } */}
                    </Fragment>,
                    // filters: [
                    //     { value: 1, text: this.props.t(`item.order.paymentStatusEnum.1`) },
                    //     { value: 2, text: this.props.t(`item.order.paymentStatusEnum.2`) },
                    //     { value: 4, text: this.props.t(`item.order.paymentStatusEnum.4`) },
                    // ],
                    // filterMultiple: false,
                },
                paymentType: {
                    key: 'paymentType',
                    render: (paymentType, data) => <Fragment>
                        {paymentType && <div className="g-mt-5">
                                <HMS.StatusComponent color={'gray'}
                                    label={i18n.t(`item.order.paymentTypes.${data.paymentType}`)} />
                        </div>
                        }
                    </Fragment>,
                    filters: [
                        { value: 'vnpay', text: this.props.t(`item.order.paymentTypes.vnpay`) },
                        { value: 'onepay', text: this.props.t(`item.order.paymentTypes.onepay`) },
                        // { value: 'zalo', text: this.props.t(`item.order.paymentTypes.zalo`) },
                        // { value: 'shopeepay', text: this.props.t(`item.order.paymentTypes.shopeepay`) },
                        { value: 'paylater', text: this.props.t(`item.order.paymentTypes.paylater`) },
                        { value: 'cash', text: this.props.t(`item.order.paymentTypes.cash`) },
                        { value: 'transfer', text: this.props.t(`item.order.paymentTypes.transfer`) },
                        { value: 'qrcode', text: this.props.t(`item.order.paymentTypes.qrcode`) },
                        { value: 'other', text: this.props.t(`item.order.paymentTypes.other`) },
                        { value: 'momo', text: this.props.t(`item.order.paymentTypes.momo`) },
                        { value: 'twoc2p', text: this.props.t(`item.order.paymentTypes.twoc2p`) },
                    ],
                    filterMultiple: false,
                },
                saleChannel: {
                    key: 'saleChannel',
                    render: (value, data) => value && i18n.t(`item.order.saleChannels.${value}`),
                    filters: Object.keys(SALE_CHANNELS).map(item => ({ value: SALE_CHANNELS[item], text: this.props.t(`item.order.saleChannels.${SALE_CHANNELS[item]}`) })),
                    filterMultiple: false,
                },
                channel: {
                    key: 'channels',
                    render: (value, data) => value && i18n.t(`item.order.channels.${value}`),
                    filters: Object.keys(CHANNELS).map(item => (
                        { value: CHANNELS[item], text: this.props.t(`item.order.channels.${CHANNELS[item]}`) 
                    })),
                    filterMultiple: true,
                },
                itemTypes: {
                    key: 'itemTypes',
                    width: 100,
                    render: (types) => (
                        <Fragment>
                            {(types || []).map(type => {
                                const typeKey = find(Object.keys(ORDER.TYPES), k => ORDER.TYPES[k].id === type)
                                return typeKey && <ANT.Tooltip key={typeKey} title={this.props.t(`item.order.orderTypes.${ORDER.TYPES[typeKey].key}`)}><Span className="ml-2">
                                    <FontIcon key={type} color={ORDER.TYPES[typeKey].color} icon={SolidIcons[ORDER.TYPES[typeKey].icon]} size="lg" />
                                </Span></ANT.Tooltip>
                            })}
                        </Fragment>
                    ),
                    filters: Object.keys(ORDER.TYPES).map(k => ({ value: ORDER.TYPES[k].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES[k].key}`) })),
                    filterMultiple: true,
                },
            },
        };
    }

    componentDidMount() {
        permisionActions = getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ORDER);
    }

    render() {
        const { t, report, downloading } = this.props;
        const { saleReportByOrderItems } = report;

        return (
            <Wrapper className="col-md-12 p-0 mt-3 report-list">
                <Wrapper className="col-md-12 row m-0 p-0 report-list-title align-items-end">
                    <h3 className={`col-md-2 ml-0 p-0`}>{t('item.report.revenue')}</h3>
                    <Wrapper className={`col-md-6 m-0 p-0 pr-2 button-section`}>
                        {permisionActions && permisionActions.allowExportExcludeUserInfo &&
                        <Button type="primary" onClick={() => this.onExportExcel(true)}
                            icon="download" loading={downloading}
                            disabled={!(saleReportByOrderItems.items && saleReportByOrderItems.items.length)}
                            className="mr-2">{t(`item.report.exportExcelExcludeUser`)}</Button>
                        }
                        { permisionActions && permisionActions.allowExportFileExcel &&
                        <Button type="primary" onClick={() => this.onExportExcel(false)}
                            icon="download" loading={downloading}
                            disabled={!(saleReportByOrderItems.items && saleReportByOrderItems.items.length)}
                            className="mr-2">{t(`item.report.exportExcel`)}</Button>
                        }
                    </Wrapper>
                    <Wrapper className={`align-items-end col-md-4 d-flex flex-column m-0 p-0`}>
                        <ButtonGroup>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.DATE })}>{t(`item.report.currentDate`)}</Button>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.WEEK })}>{t(`item.report.currentWeek`)}</Button>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.MONTH })}>{t(`item.report.currentMonth`)}</Button>
                        </ButtonGroup>
                        <DatePickerComponent className={`form-control applyDates w100-percent mt-1`}
                            hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                            style={{ padding: 0, border: 0 }}
                            onChange={this.onSelectDateRange} name={`applyDates`}
                            placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                            value={[saleReportByOrderItems.startDate, saleReportByOrderItems.endDate]}
                        />
                    </Wrapper>
                </Wrapper>
                {this.renderList()}
            </Wrapper>
        );
    }

    renderList() {
        const { report, loading } = this.props;
        const { saleReportByOrderItems } = report;
        const { items } = saleReportByOrderItems
        const filters = omit(saleReportByOrderItems, 'items')
        const { titleItemTable, modelItem, componentTable } = this.state;

        return (
            <Wrapper className={`mt-2`}>
                <ListComponent
                    tableKey="sale-report-list"
                    scroll={{ x: 2200, y: 450 }}
                    classParent="m-0 p-0 sale-report-list"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => record.id}
                    dataSource={getDataSource(items || [], modelItem)}
                    columns={columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'order'
                    })}
                    pagination={{ total: filters.totalCount, totalPage: filters.totalPage, current: filters.pageIndex, pageSize: filters.pageSize }}
                    onChange={this.onTableChange}
                    componentTableList={{}}
                />
            </Wrapper>
        )
    }

    onSelectDateRange = (data) => {
        const filters = this.getCurrentFilters()
        filters.pageIndex = 1;
        filters.startDate = moment.utc(data.value[0], DATE_TIME_FORMAT.SHORT_DATE);
        filters.endDate = moment.utc(data.value[1], DATE_TIME_FORMAT.SHORT_DATE).endOf('day');
        return this.props.onChangeFilters({ ...this.state.filterExport, ...filters });
    }

    onTableChange = (pagination, filters, sorter) => {
        const currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({ filterExport: newFilters })
        this.props.onChangeFilters(newFilters);
    };

    onChangeFilters = (fieldName, value) => {
        const filters = this.getCurrentFilters()
        filters[fieldName] = value;
        return this.props.onChangeFilters({ ...this.state.filterExport, ...filters })
    }

    onExportExcel = (isExcludeUserInfo = false) => {
        const filters = this.getCurrentFilters();
        filters.paymentStatus = ORDER.STATUS.PAID;
        filters.pageIndex = undefined;
        filters.pageSize = undefined;
        filters.isExcludeUserInfo = isExcludeUserInfo;
        return this.props.onExportExcel(parseListRequestParams({ ...this.state.filterExport, ...filters }));
    }

    getCurrentFilters() {
        const { report } = this.props;
        const { saleReportByOrderItems } = report;
        return omit(saleReportByOrderItems, ['items', 'totalCount', 'totalPage']);
    }

}

ReportList.defaultProps = {
    report: new SaleReportByOrder(),
    loading: false,
    downloading: false,
    onChangeFilters: filters => { },
    onExportExcel: filters => { },
}

